const DOWNLOAD_URL = "/api/remotion-claude-guide/download";
const NEWSLETTER_URL = "https://elianajourney.substack.com/";

const Hero: React.FC = () => {
  return (
    <section className="bg-black text-white pt-16 pb-12 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <div className="inline-block bg-cyan-400/10 border border-cyan-400/30 rounded-full px-4 py-1 mb-6">
          <span className="text-cyan-400 text-xs font-bold uppercase tracking-widest">
            🎬 Free Guide · Instant Download
          </span>
        </div>

        <h1 className="sm:hidden text-4xl font-extrabold mb-6 leading-tight tracking-tight">
          Create pro videos with
          <span className="text-cyan-400"> Remotion + Claude</span>
        </h1>

        <h1 className="hidden sm:block text-4xl md:text-6xl font-extrabold mb-6 leading-tight tracking-tight">
          Create pro videos with <br />
          <span className="text-cyan-400">Remotion + Claude</span>
        </h1>

        <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-10 max-w-2xl mx-auto">
          <img
            src="/images/eliana-boat-3.png"
            alt="Eliana"
            className="w-20 h-20 md:w-24 md:h-24 object-cover rounded-full border-2 border-cyan-400 shadow-[0_0_15px_rgba(34,211,238,0.3)]"
          />
          <div className="text-left">
            <p className="text-lg text-gray-200 leading-snug">
              <strong>I'm Eliana.</strong> Scuba instructor turned indie hacker. I built this guide to show you exactly how I use Claude to write Remotion compositions — motion graphics, product demos, and social content without a video editor.
            </p>
          </div>
        </div>

        <div className="flex flex-col items-center">
          <a
            href={DOWNLOAD_URL}
            className="bg-cyan-400 hover:bg-cyan-300 text-black hover:text-black font-bold py-4 px-12 rounded-full text-xl transition-all hover:scale-105 shadow-lg shadow-cyan-400/20"
          >
            Download the Free PDF
          </a>

          <p className="text-sm text-gray-400 mt-4">
            100% Free · Instant Access · No email required
          </p>

          <a
            href={NEWSLETTER_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 text-cyan-400 hover:text-cyan-300 font-semibold text-md underline underline-offset-4 transition-colors"
          >
            And subscribe to my newsletter →
          </a>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 text-left border-t border-zinc-800 pt-10 text-lg">
          <div>
            <h3 className="text-cyan-400 font-bold mb-1">Remotion Basics</h3>
            <p className="sm:text-md text-sm text-gray-400">
              Set up compositions, sequences, and render pipeline from scratch.
            </p>
          </div>
          <div>
            <h3 className="text-cyan-400 font-bold mb-1">Claude Workflow</h3>
            <p className="sm:text-md text-sm text-gray-400">
              Prompts and patterns to generate motion graphics code with AI.
            </p>
          </div>
          <div>
            <h3 className="text-cyan-400 font-bold mb-1">Real Examples</h3>
            <p className="sm:text-md text-sm text-gray-400">
              Copy-paste templates for product demos and social clips.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
